import _regenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCategoryPageNotice, saveCategoryPageNotice, getChannelNoticeList } from '../api/index';
export default {
  name: 'noticeMessage',
  props: {
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      saving: false,
      form: {
        is_open_notice: 0,
        notice_id: ''
      },
      snapshot: {
        is_open_notice: 0,
        notice_id: ''
      },
      noticeOptions: []
    };
  },
  computed: {
    isChanged: function isChanged() {
      return this.form.is_open_notice !== this.snapshot.is_open_notice || Number(this.form.notice_id || 0) !== Number(this.snapshot.notice_id || 0);
    }
  },
  methods: {
    getDetail: function getDetail() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$info, customer_id, category_id, res, data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _this$info = _this.info, customer_id = _this$info.customer_id, category_id = _this$info.category_id;
              _context.n = 1;
              return getCategoryPageNotice({
                customer_id: customer_id,
                category_id: category_id
              });
            case 1:
              res = _context.v;
              data = res.data || {};
              _this.form = {
                is_open_notice: Number(data.is_open_notice) || 0,
                notice_id: data.notice_id || ''
              };
              _this.snapshot = _objectSpread({}, _this.form);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    getNoticeOptions: function getNoticeOptions() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var res;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return getChannelNoticeList({
                customer_id: _this2.info.customer_id
              });
            case 1:
              res = _context2.v;
              _this2.noticeOptions = res.data || [];
            case 2:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    resetForm: function resetForm() {
      this.form = _objectSpread({}, this.snapshot);
    },
    save: function save() {
      var _this3 = this;
      if (this.form.is_open_notice === 1 && !this.form.notice_id) {
        this.$message.warning('请选择通知消息');
        return;
      }
      var _this$info2 = this.info,
        customer_id = _this$info2.customer_id,
        category_id = _this$info2.category_id;
      this.saving = true;
      saveCategoryPageNotice({
        customer_id: customer_id,
        category_id: category_id,
        is_open_notice: this.form.is_open_notice,
        notice_id: this.form.is_open_notice === 1 ? this.form.notice_id : 0
      }).then(function () {
        _this3.$message.success('保存成功');
        return _this3.getDetail();
      }).finally(function () {
        _this3.saving = false;
      });
    }
  },
  created: function created() {
    this.getDetail();
    this.getNoticeOptions();
  }
};